<section class="row">
  <div class="col-10">
    <ul
      class="pagination"
      *ngIf="pages.length">
      <li
        class="page-item"
        (click)="onClickPage(activePage - 1)">
        <a
          class="page-link"
          href="javascript:void(0);"
          >&laquo; Previous</a
        >
      </li>
      <li
        class="page-item"
        [ngClass]="{ active: activePage === item }"
        *ngFor="let item of pages"
        (click)="onClickPage(item)">
        <a
          class="page-link"
          href="javascript:void(0);"
          >{{ item }}</a
        >
      </li>
      <li
        class="page-item"
        (click)="onClickPage(activePage + 1)">
        <a
          class="page-link"
          href="javascript:void(0);"
          >Next &raquo;</a
        >
      </li>
    </ul>
  </div>
  <div class="col-2">{{ totalRecords }} items</div>
</section>
